/* eslint-disable no-unused-vars */
const lozad = require('lozad');
const constants = require('../constants');
const utils = require('../utils');

/**
 * Trigger lozad
 */
function triggerLozad() {
    if(window.innerWidth < 1024) {      
      $('.product-tile .secondary-tile-image').remove();
    }
    const observer = lozad('.lozad', {
        enableAutoReload: true,
        loaded: (el) => {
            const thisElem = $(el);
            thisElem.addClass('fade-loaded');
            if (thisElem.parents('.product-tile').length && thisElem.parents('.product-tile').attr('data-futurepromotiondate')) {
                utils.displayFuturePromotionsInfo(thisElem.parents('.product-tile'));
            }
        },
    });
    observer.observe();
}

function domObserverFunction() {
    const targetNode = document.querySelector('.page');
    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationsList, observer) => {
        if (mutationsList.some(mutation => $(mutation.target).find('img.lozad'))) {
            mutationsList.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    triggerLozad();
                });
            });
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    triggerLozad();
}

module.exports = {
    domObserverFunction,
};
